import {TimelineMax, Power0, Sine} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');

const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');



    const createCloud = cloudname => {
        return Shortcuts.getCenteredSpriteInCont(cloudname, TextureCache);
    }

    Shortcuts.addTo(createCloud('cl2'), 'cl3', cont);
    Shortcuts.addTo(createCloud('cl9'), 'cl9', cont);
    Shortcuts.addTo(createCloud('cl9'), 'cl11', cont);
    Shortcuts.addTo(createCloud('cl4'), 'cl1', cont);
    Shortcuts.addTo(createCloud('cl4'), 'cl7', cont);
    Shortcuts.addTo(createCloud('cl7'), 'cl2', cont);
    Shortcuts.addTo(createCloud('cl5'), 'cl4', cont);
    Shortcuts.addTo(createCloud('cl5'), 'cl10', cont);
    Shortcuts.addTo(createCloud('cl6'), 'cl5', cont);
    Shortcuts.addTo(createCloud('cl6'), 'cl12', cont);
    Shortcuts.addTo(createCloud('cl6'), 'cl8', cont);
    Shortcuts.addTo(createCloud('cl3'), 'cl6', cont);


    cont.cl3.alpha = 0;
    cont.cl9.alpha = 0;
    cont.cl11.alpha = 0;
    cont.cl1.alpha = 0;
    cont.cl7.alpha = 0;
    cont.cl2.alpha = 0;
    cont.cl4.alpha = 0;
    cont.cl10.alpha = 0;
    cont.cl5.alpha = 0;
    cont.cl12.alpha = 0;
    cont.cl8.alpha = 0;
    cont.cl6.alpha = 0;


    cont.cl3.z = 1.2;
    cont.cl9.z = 1.3;
    cont.cl11.z = 1.4;
    cont.cl1.z = 1.45;
    cont.cl7.z = 1.5;
    cont.cl2.z = 1.48;
    cont.cl4.z = 1.52;
    cont.cl10.z = 1.6;
    cont.cl5.z = 1.65;
    cont.cl12.z = 1.67;
    cont.cl8.z = 1.7;
    cont.cl6.z = 1.75;

    cont.cl6.img.scale.x = -1;
    cont.cl9.img.scale.x = -1;

    // cont.scale.x = cont.scale.y = sizes.width / 3200;

    cont.x = sizes.width / 2;
    cont.y = sizes.height / 2;


    instance.cont = cont;

    instance.width = sizes.coverWidth;
    instance.height = sizes.coverHeight;
    instance.parallaxLayers = cont.children;

    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _constructTimeline = (instance, config) => {
    const tl = new TimelineMax({paused: true});
    const cont = instance.cont;
    const a = config.durationRatio;

    const __getRad = Shortcuts.getRad;

    tl.set(cont, {alpha:0}, 'set');
    tl.to(cont, a * 30, {alpha:1, ease: Sine.easeIn}, 'set');
    // tl.to(cont, a * 8, {alpha:1}, 'set');

    // __________________L1 _ rght_______________
    tl.set(cont.cl1.scale, {x:1, y:1}, 'set');
    tl.set(cont.cl1, {alpha:1, rotation: 0, x:560, y:-200}, 'set');
    tl
         .to(cont.cl1.scale,  a * 42, {x:1.6, y:1}, 'set')
         .to(cont.cl1,  a * 42, {rotation:__getRad(-20), x:1993, y:-250}, 'set');

    // __________________L2 _ rght_______________
    tl.set(cont.cl2.scale, {x:1, y:0.8}, 'set');
    tl.set(cont.cl2, {alpha:1, rotation: 0, x:-500, y:232}, 'set');
    tl
        .to(cont.cl2.scale,  a * 38, {x:1.2, y:0.5, ease:Power0.easeNone}, 'set')
        .to(cont.cl2,  a * 38, {rotation:__getRad(20), x:1120, ease:Power0.easeNone}, 'set');


    // __________________L3 _rght_______________
    tl.set(cont.cl3.scale, {x:1, y:0.8}, 'set');
    tl.set(cont.cl3, {alpha:0, rotation: 0, x:-166, y:0}, 'set');
    tl
        .to(cont.cl3,  a * 8, {alpha:1}, 'set')
        .to(cont.cl3.scale,  a * 38, {x:1.2, y:0.5, ease:Power0.easeNone}, 'set')
        .to(cont.cl3,  a * 38, {rotation:__getRad(20), x:1800, ease:Power0.easeNone}, 'set')
        .to(cont.cl3,  a * 8, {alpha:0}, 'set+=' + a * 20);

    // __________________L4 _ rght_______________
    tl.set(cont.cl4, {alpha:1, rotation: __getRad(20), x:567, y:26}, 'set');
    tl
        .to(cont.cl4,  a * 38, {rotation:__getRad(-10), x:2569, y:73}, 'set');

// __________________L5 _ rght_______________

    tl.set(cont.cl5.scale, {x:0.5, y:0.5}, 'set');
    tl.set(cont.cl5, {alpha:1, rotation: __getRad(20), x:-1409, y:-780}, 'set');
    tl
        .to(cont.cl5.scale, a * 10, {x:0.72, y:0.72, ease:Power0.easeNone}, 'set')
        .to(cont.cl5.scale, a * 7, {x:1, y:1, ease:Power0.easeNone}, 'set+=' + a * 10)
        .to(cont.cl5.scale, a * 28, {x:0.5, y:0.5, ease:Power0.easeNone}, 'set+=' + a * 17)
        .to(cont.cl5,  a * 10, {rotation:__getRad(15), x:-982, y:-540, ease:Power0.easeNone}, 'set')
        .to(cont.cl5,  a * 7, {rotation:__getRad(13.4), x:-323, y:-151, ease:Power0.easeNone}, 'set+=' + a * 10)
        .to(cont.cl5,  a * 16, {rotation:__getRad(-10), x:720, y: 80, ease:Power0.easeNone}, 'set+=' + a * 17)
        .to(cont.cl5,  a * 12, {rotation:__getRad(-10), x:1500, y: 80, ease:Power0.easeNone}, 'set+=' + a * 35)
        .to(cont.cl5,  a * 8, {alpha:0}, 'set+=' + a * 27);

// __________________L6 _ rght_______________
    tl.set(cont.cl6.scale, {x:1, y:1}, 'set');
    tl.set(cont.cl6, {alpha:1, rotation: 0, x:390, y:100}, 'set');
    tl
        .to(cont.cl6.scale,  a * 28, {x:1.6, y:1}, 'set')
        .to(cont.cl6,  a * 28, {rotation:__getRad(-20), x:2399, y:100}, 'set');


    // __________________L7 _ rght_______________
    tl.set(cont.cl7.scale, {x:1, y:0.8}, 'set');
    tl.set(cont.cl7, {alpha:1, rotation: 0, x:-900, y:-170}, 'set');
    tl
        .to(cont.cl7.scale,  a * 2, {x:1, y:0.814}, 'set')
        .to(cont.cl7.scale,  a * 42, {x:1.2, y:0.5, ease:Power0.easeNone}, 'set+=' + a * 2)
        .to(cont.cl7,  a * 2, {rotation:__getRad(0.74), x:-840, y:-129, ease:Power0.easeNone}, 'set')
        .to(cont.cl7,  a * 25, {y:380, ease:Power0.easeNone}, 'set+=' + a * 2)
        .to(cont.cl7,  a * 42, {rotation:__getRad(40), x:1500, ease:Power0.easeNone}, 'set+=' + a * 2)
        .to(cont.cl7,  a * 12, {alpha:0}, 'set+=' + a * 15);

    // __________________L8 _ rght_______________
    tl.set(cont.cl8.scale, {x:0.5, y:0.5}, 'set');
    tl.set(cont.cl8, {alpha:0, rotation: __getRad(5), x:-900, y:-170}, 'set');
    tl
        .to(cont.cl8,  a * 13, {alpha:0.5}, 'set+=' + a * 2)
        .to(cont.cl8,  a * 27, {y:20, ease:Power0.easeNone}, 'set+=' + a * 2)
        .to(cont.cl8,  a * 42, {rotation:__getRad(5), x:1900, ease:Power0.easeNone}, 'set+=' + a * 2)
        .to(cont.cl8,  a * 12, {alpha:0}, 'set+=' + a * 15);

    // __________________L9 _ rght_______________
    tl.set(cont.cl9.scale, {x:1, y:1}, 'set');
    tl.set(cont.cl9, {alpha: 1,  x:-1000, y:-107}, 'set');
    tl
        .to(cont.cl9.scale,  a * 68, {x:0.5, y:0.7, ease:Power0.easeNone}, 'set')
        .to(cont.cl9,  a * 68, {alpha: 1, x:2300, y:400, ease:Power0.easeNone}, 'set')

        .to(cont.cl9,  a * 12, {alpha:0.7}, 'set+=' + a * 35)
        .to(cont.cl9,  a * 8, {alpha:0}, 'set+=' + a * 50);

    // __________________L10 _ rght_______________
    tl.set(cont.cl10, {alpha: 0, rotation: 0, x:350, y:3}, 'set');
    tl

        .to(cont.cl10,  a * 45, {x:1250, y:-360, ease:Power0.easeNone}, 'set')
        .to(cont.cl10,  a * 10, {alpha:1}, 'set+=' + a * 5)
        .to(cont.cl10,  a * 5, {alpha:0.7}, 'set+=' + a * 15)
        .to(cont.cl10,  a * 8, {alpha:0}, 'set+=' + a * 20);

    // __________________L11 _ rght_______________
    tl.set(cont.cl11.scale, {x:1, y:1}, 'set');
    tl.set(cont.cl11, {alpha: 1, rotation: 0, x:900, y:0}, 'set');
    tl
        .to(cont.cl11.scale,  a * 68, {x:1, y:0.1, ease:Power0.easeNone}, 'set')
        .to(cont.cl11,  a * 68, {x:3300, y:200, ease:Power0.easeNone}, 'set')
        .to(cont.cl11,  a * 12, {alpha:0.7}, 'set+=' + a * 15)
        .to(cont.cl11,  a * 8, {alpha:0}, 'set+=' + a * 30);



    // __________________L12 _ rght_______________
    tl.set(cont.cl12, {alpha: 1, rotation: 0, x:-500, y:242}, 'set');
    tl
        .to(cont.cl12,  a * 78, {alpha: 1, x:1555, y:200, rotation: __getRad(20), ease:Power0.easeNone}, 'set')
        .to(cont.cl12,  a * 10, {alpha:0.7}, 'set+=' + a * 40)
        .to(cont.cl12,  a * 8, {alpha:0}, 'set+=' + a * 50);



    instance.timeline = tl;
    return tl;
}

function BattleSmokeTimeline(app, root, duration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        const config = {
            durationRatio: duration / 58
        }
        _addView(instance, config);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance'], config);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = duration * 0.3;
    constructor.totalDuration = duration;

    return constructor;
}

module.exports = BattleSmokeTimeline;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/BattleSmokeTimeline.js